import React, { useState } from 'react';
import './Contact.css';

const WEB3FORMS_ACCESS_KEY = '65f0110e-9751-4192-8920-f96cbcedb594';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: 'assessment',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: `Consultation Request - ${formData.service} from ${formData.name}`,
          from_name: formData.name,
          name: formData.name,
          email: formData.email,
          company: formData.company,
          service: formData.service,
          message: formData.message,
          botcheck: ''
        })
      });

      const result = await response.json();

      if (result.success) {
        setStatus({ type: 'success', message: 'Thank you! Your request has been sent. I\'ll be in touch shortly.' });
        setFormData({ name: '', email: '', company: '', service: 'assessment', message: '' });
      } else {
        setStatus({ type: 'error', message: 'Something went wrong. Please try again or email me directly.' });
      }
    } catch {
      setStatus({ type: 'error', message: 'Unable to send your message. Please email me directly at timjamespatterson@gmail.com' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h1>Book a Consultation</h1>
          <p>Let's discuss how I can help secure your organisation</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h2>Why Choose My Services?</h2>
            <ul>
              <li>Certified Cybersecurity Professional</li>
              <li>Comprehensive Security Assessments</li>
              <li>Customised Solutions for Your Business</li>
              <li>Clear, Actionable Recommendations</li>
            </ul>

            <div className="contact-details">
              <h3>Contact Information</h3>
              <p>Email: timjamespatterson@gmail.com</p>
              <p>Location: Gold Coast, Australia</p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="company">Company Name</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="service">Service Required</label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="assessment">Security Assessment</option>
                <option value="infrastructure">Infrastructure Review</option>
                <option value="training">Security Training</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Additional Information</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                placeholder="Please provide any specific requirements or questions..."
              ></textarea>
            </div>

            {status.message && (
              <div className={`form-status form-status--${status.type}`}>
                {status.message}
              </div>
            )}

            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Request Consultation'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
